module.exports = __webpack_public_path__ + "img/ic-logo-payfast.00f5bbe1.svg";